// Checks if the element is stable by checking if the bounding client rect is the same for a period of time const isElementStable = async (element: HTMLElement) => {
//   // Arbitrary time between checks
// const timeBetweenChecks = 10; let previousBoundingClientRect = element.getBoundingClientRect();

// for (let i = 0; i < 40; i++) { await new Promise((resolve) => setTimeout(resolve, timeBetweenChecks)); const currentBoundingClientRect = element.getBoundingClientRect(); if ( previousBoundingClientRect.left === currentBoundingClientRect.left && previousBoundingClientRect.right === currentBoundingClientRect.right && previousBoundingClientRect.top === currentBoundingClientRect.top && previousBoundingClientRect.bottom === currentBoundingClientRect.bottom ) {
//       // break;
//     }

// previousBoundingClientRect = currentBoundingClientRect; } };

const getAnimations = (element: HTMLElement): Animation[] => {
  // Arbitrary limit to how far up we check for animations
  const maxDepth = 20;

  // First add the element to the list of animations
  const animationsAll = [...element.getAnimations()];

  // Get animations of parent elements up to the max depth
  let parent = element.parentElement;
  for (let i = 0; i < maxDepth; i++) {
    if (parent !== null) {
      animationsAll.push(...parent.getAnimations());
      parent = parent.parentElement;
    } else {
      // No more parent elements, break
      break;
    }
  }

  return animationsAll;
};

export const waitForAnimationsToComplete = async (element: HTMLElement) => {
  // Get all current animations
  const animations = getAnimations(element);

  // Wait for all current animations to complete
  if (animations.length > 0) {
    await Promise.all(animations.map((animation) => animation.finished));
  }

  // Always do a light final wait to make the UI less jarring Arbitrary wait time
  const finalWaitTime = 100;
  await new Promise((resolve) => setTimeout(resolve, finalWaitTime));
};
